/**
 * The action when condition is satisfied
 */
export var SatisfiedActionType;
(function (SatisfiedActionType) {
    SatisfiedActionType["Show"] = "show";
    SatisfiedActionType["Hide"] = "hide";
})(SatisfiedActionType || (SatisfiedActionType = {}));
